import { useState, type Dispatch, type SetStateAction } from 'react';
import { Outlet } from 'react-router-dom';
import ToolsBreadcrumb from '../common/components/ToolsBreadcrumb';

export type BreadcrumbItem = { text: string; href: string };
export type SettingsOutletContext = [
  BreadcrumbItem[],
  Dispatch<SetStateAction<BreadcrumbItem[]>>
];

const Settings = () => {
  const [breadcrumbData, setBreadcrumbData] = useState<BreadcrumbItem[]>([]);

  return (
    <>
      <ToolsBreadcrumb
        parentName="تنظیمات"
        parentUrl={`/settings/appearance`}
        childs={breadcrumbData}
      />
      <Outlet context={[breadcrumbData, setBreadcrumbData] satisfies SettingsOutletContext} />
    </>
  );
};

export default Settings;
